import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  dashboard: "/dashboard/stats",
};

export const fetchDashboardStats = createAsyncThunk(
  "dashboard/fetchDashboardStats",
  async (params: Params & { establishment_slug?: string }, thunkAPI) => {
    try {
      const { establishment_slug, ...query } = params as any;
      // Se slug for fornecido, garante baseURL raiz e inclui slug no path para evitar duplicação
      if (establishment_slug) {
        const url = `/establishment/${establishment_slug}/dashboard/stats`;
        const response = await axiosInstance.get(url, {
          params: query,
          baseURL: process.env.NEXT_PUBLIC_API_URL,
        } as any);
        return response.data;
      }

      // Fallback: usa baseURL atual (que pode já conter o slug) + path simples
      const response = await axiosInstance.get(endpoint.dashboard, {
        params: query,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const backend = error.response?.data as {
          message?: string;
          errors?: any;
        };
        return thunkAPI.rejectWithValue({
          message: backend?.message || "Erro desconhecido.",
          errors: backend?.errors || {},
        });
      }
      return thunkAPI.rejectWithValue({
        message: "Erro inesperado.",
        errors: {},
      });
    }
  },
);
